module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "fm1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fmhT"
  }, [_c('i', [_vm._v("The Main Characters")])]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_vm._v("LONDON")]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_vm._v("Lady Celia Lytton, "), _c('i', [_vm._v("senior editor at Lyttons publishing house")])]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_vm._v("Lord Arden, "), _c('i', [_vm._v("her new husband")])]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_vm._v("Giles, "), _c('i', [_vm._v("twins")]), _vm._v(" Venetia "), _c('i', [_vm._v("and")]), _vm._v(" Adele, "), _c('i', [_vm._v("and")]), _vm._v(" Kit, "), _c('i', [_vm._v("her children")])]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_vm._v("Jay Lytton, "), _c('i', [_vm._v("their cousin")])]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_vm._v("Boy Warwick, "), _c('i', [_vm._v("Venetia’s husband")])]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_vm._v("Elspeth Warwick, "), _c('i', [_vm._v("their daughter")])]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_vm._v("Keir Brown, "), _c('i', [_vm._v("Elspeth’s boyfriend")])]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_vm._v("Geordie MacColl, "), _c('i', [_vm._v("Adele’s husband")])]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_vm._v("Clio, "), _c('i', [_vm._v("their daughter")])]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_vm._v("Noni "), _c('i', [_vm._v("and")]), _vm._v(" Lucas, "), _c('i', [_vm._v("Adele’s children by Luc Lieberman, deceased")])]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_vm._v("Sebastian Brooke, "), _c('i', [_vm._v("bestselling author published by Lyttons")])]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_vm._v("Clementine Hartley, "), _c('i', [_vm._v("another Lyttons author")])]), _vm._v(" "), _c('div', [_c('br')]), _c('div', {
    staticClass: "fmtx1"
  }, [_vm._v("COUNTRY")]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_vm._v("Billy Miller, "), _c('i', [_vm._v("brother of Barty")])]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_vm._v("Joan, "), _c('i', [_vm._v("his wife, and their sons")]), _vm._v(" Joe "), _c('i', [_vm._v("and")]), _vm._v(" Michael")]), _vm._v(" "), _c('div', [_c('br')]), _c('div', {
    staticClass: "fmtx1"
  }, [_vm._v("NEW YORK")]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_vm._v("Barty Miller, "), _c('i', [_vm._v("head of Lyttons New York")])]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_vm._v("Jenna Elliott, "), _c('i', [_vm._v("her daughter by Laurence Elliott,deceased")])]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_vm._v("Cathy Patterson, "), _c('i', [_vm._v("a schoolfriend of Jenna’s")])]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_vm._v("Charlie Patterson, "), _c('i', [_vm._v("her father")])]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_vm._v("Jamie Elliott, "), _c('i', [_vm._v("brother of Laurence and Jenna’s trustee")])]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_vm._v("Kyle Brewer, "), _c('i', [_vm._v("a literary agent and Jenna’s trustee")])]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_vm._v("Marcus Forrest, "), _c('i', [_vm._v("editorial director of Lyttons New York")])]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_vm._v("Isabella (Izzie)Brooke, "), _c('i', [_vm._v("Sebastian’s daughter")])]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_vm._v("Mike Parker and Nick Neill, "), _c('i', [_vm._v("copywriters, Izzie’s employers")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e20802e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vinc_9781590208007_oeb_fm1_r1.vue
// module id = 78
// module chunks = 0